import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

import { Button } from '../../ui/button'
import { Label } from '../../ui/label'
import { Input } from '../../ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select'
import { Checkbox } from '../../ui/checkbox'
import FacilityMultiSelect from '../shared/FacilityMultiSelect'

function MonthlyLtsForm({ form, facilities, onSubmit, isSubmitting, isFacilityScoped = false, demo = false }) {
  const { control, handleSubmit, register } = form

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div className="space-y-4">
        <div>
          <Label htmlFor="days_back">Look Back Period (Days)</Label>
          <Input
            id="days_back"
            type="number"
            min="1"
            max="365"
            {...register('days_back', { valueAsNumber: true })}
            className="mt-1"
          />
          <p className="text-sm text-gray-500 mt-1">Find students without LTS numbers from the last X days</p>
        </div>

        {!isFacilityScoped && (
          <div>
            <Label>Facilities</Label>
            <Controller
              name="facility_ids"
              control={control}
              render={({ field }) => (
                <FacilityMultiSelect facilities={facilities} value={field.value} onChange={field.onChange} />
              )}
            />
            <p className="text-sm text-gray-500 mt-1">Leave empty for all facilities</p>
          </div>
        )}

        <div>
          <Label htmlFor="file_format">File Format</Label>
          <Controller
            name="file_format"
            control={control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger className="mt-1">
                  <SelectValue placeholder="Select format" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="csv">CSV</SelectItem>
                  <SelectItem value="xls">Excel (XLS)</SelectItem>
                  <SelectItem value="pdf">PDF</SelectItem>
                </SelectContent>
              </Select>
            )}
          />
        </div>

        <div hidden={demo}>
          <Label>Delivery Method</Label>
          <Controller
            name="delivery_method"
            control={control}
            render={({ field }) => (
              <div className="space-y-2 mt-2">
                <div className="flex items-center space-x-2">
                  <Checkbox
                    id="email"
                    checked={field.value === 'email' || field.value === 'both'}
                    disabled={field.value === 'email'}
                    onCheckedChange={(checked) => {
                      if (checked && field.value === 'download') {
                        field.onChange('both')
                      } else if (checked) {
                        field.onChange('email')
                      } else if (field.value === 'both') {
                        field.onChange('download')
                      }
                    }}
                  />
                  <Label htmlFor="email" className="font-normal cursor-pointer">
                    Email me when ready
                  </Label>
                </div>
                <div className="flex items-center space-x-2">
                  <Checkbox
                    id="download"
                    checked={field.value === 'download' || field.value === 'both'}
                    disabled={field.value === 'download'}
                    onCheckedChange={(checked) => {
                      if (checked && field.value === 'email') {
                        field.onChange('both')
                      } else if (checked) {
                        field.onChange('download')
                      } else if (field.value === 'both') {
                        field.onChange('email')
                      }
                    }}
                  />
                  <Label htmlFor="download" className="font-normal cursor-pointer">
                    Available for download
                  </Label>
                </div>
              </div>
            )}
          />
        </div>
      </div>

      <Button type="submit" disabled={isSubmitting} className="w-full">
        {isSubmitting ? 'Generating Preview...' : 'Preview Report'}
      </Button>
    </form>
  )
}

MonthlyLtsForm.propTypes = {
  demo: PropTypes.bool,
  form: PropTypes.object.isRequired,
  facilities: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isFacilityScoped: PropTypes.bool
}

export default MonthlyLtsForm
